import React, { PropsWithChildren } from "react";
import { useNavigate } from "react-router-dom";
import { SerializedStyles } from "@emotion/react";
import { withIsVisible } from "utils/reactUtils";
import { Text, TextSize } from "components/general/Text";
import { GlobalStore } from "store/global/GlobalStore";
import { ButtonContainer } from "./elements/ButtonContainer";

export type ColorType = "primary" | "secondary" | "quaternary" | "tertiary" | "link";

export enum ButtonBorderRadius {
  Large = "30px",
  Medium = "21px",
  Mid = "14px",
  Small = "8px",
  ExtraSmall = "4px",
}
export interface BaseButtonProps {
  buttonType?: ColorType;
  shape?: "round" | "square";
  height?: number;
  widthExpand?: boolean;
  width?: number;
  buttonCss?: SerializedStyles;
  padding?: `${string}px`;
  isDisabled?: boolean;
  hasActiveState?: boolean;
  isWaiting?: boolean;
  target?: string;
  rel?: string;
}
interface ButtonProps extends BaseButtonProps {
  navigateTo?: string;
  text?: string;
  textSize?: TextSize<"Button">;
}

export const Button = withIsVisible(
  ({
    navigateTo,
    text,
    textSize,
    buttonType,
    shape = "round",
    height,
    padding,
    widthExpand = false,
    width,
    buttonCss,
    children,
    isDisabled,
    isWaiting,
    ...props
  }: PropsWithChildren<ButtonProps & React.HTMLAttributes<HTMLButtonElement>>) => {
    const navigate = useNavigate();
    const theme = GlobalStore.useState(s => s.theme);

    return (
      <ButtonContainer
        onClick={e => {
          if (props.onClick) {
            props.onClick(e);
          }
          if (navigateTo?.startsWith("https")) {
            window.open(navigateTo, "_blank");
          } else if (navigateTo) {
            navigate(navigateTo);
          }
        }}
        buttonType={buttonType}
        shape={shape}
        height={height}
        widthExpand={widthExpand}
        padding={padding}
        width={width}
        css={buttonCss}
        theme={theme}
        disabled={isDisabled}
        isWaiting={isWaiting}
        {...props}
      >
        {children ? (
          children
        ) : (
          <Text textStyle="Button" size={textSize ?? "Large"}>
            {text}{" "}
          </Text>
        )}
      </ButtonContainer>
    );
  }
);
